module.exports = {
      id: "twitter-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.789192dd.svg#twitter-usage",
      toString: function () {
        return this.url;
      }
    }